import React, { type ReactNode } from "react";
import {
  Button,
  ButtonSizes,
  ButtonVariants,
} from "../../../components/core/Button/Button";
import { PermissionsEnum } from "../../../constants/AppConstants";
import { useAppSelector } from "../../../hooks/store.hook";
import { ReactComponent as CalibrationIcon } from "../../../icons/calibration.svg";
import { roleHasPermission } from "../../../utils/roleAuth.utils";
import {
  PotentialMatrixHeader,
  type PotentialMatrixHeaderProps,
} from "./PotentialMatrixHeader/PotentialMatrixHeader";
import {
  StyledPotentialMatrixTabLayout,
  StyledPotentialMatrixTabContent,
  StyledPotentialMatrixTabFooter,
} from "./PotentialMatrixTabLayout.styled";

export type PotentialMatrixTabFooterProps = {
  onClick: () => void;
  label: string;
};

export type PotentialMatrixTabLayoutProps = {
  headerProps: PotentialMatrixHeaderProps;
  footerProps?: PotentialMatrixTabFooterProps;
  children: ReactNode;
  hideScroll?: boolean;
};

export const PotentialMatrixTabLayout = ({
  headerProps,
  footerProps,
  children,
  hideScroll = false,
}: PotentialMatrixTabLayoutProps) => {
  const { profile } = useAppSelector((state) => state.user);
  const canShowFooter =
    footerProps &&
    roleHasPermission(profile, PermissionsEnum.CAN_START_DEVELOPMENT_COMMITTEE);

  return (
    <StyledPotentialMatrixTabLayout $hideScroll={hideScroll}>
      <PotentialMatrixHeader {...headerProps} />

      <StyledPotentialMatrixTabContent $hideScroll={hideScroll}>
        {children}
      </StyledPotentialMatrixTabContent>

      {canShowFooter && (
        <StyledPotentialMatrixTabFooter>
          <Button
            label={footerProps.label}
            variant={ButtonVariants.PRIMARY}
            size={ButtonSizes.SMALL}
            icon={<CalibrationIcon />}
            onClick={footerProps.onClick}
          />
        </StyledPotentialMatrixTabFooter>
      )}
    </StyledPotentialMatrixTabLayout>
  );
};
